import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import type { SpinProps } from 'antd';

export const Loader = (props: SpinProps) => (
  <Spin indicator={<LoadingOutlined spin />} {...props} />
);
